export default __webpack_public_path__ + "static/createToken-517fad8ff8c44ae89b909db55861e893.png";